<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
        <a-form layout='inline'>
          <a-form-item>
            <a-button icon="check" type="primary" @click="showEditModal()">批量跟进</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="search">
      </div>
    </div>
    <div class="table">
      
      <a-table size="middle" :pagination="false" :bordered='false' rowKey="contract_id"
        :selection="{key: 'key'}"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :columns="columns" :dataSource="list" @change="handleChange">
        <template slot="index" slot-scope="text, record , index">
          <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
        </template>

        <template slot="studentName" slot-scope="text, record">
          <LUser :data="record"/>
        </template>
          <template slot="action" slot-scope="text,record">
            <a href="javascript:;" @click="toProfile(record)">业务办理</a>
            <a-divider type="vertical" />
            <a href="javascript:;" @click="showEditModal(record)">顾问跟进</a>
          </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
    <editModal v-if="editVisible" :item="modalData"/>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index', fixed: 'left'},
  { title: '学员名称', width: '200px', dataIndex: 'student_name', key: 'student_name', fixed: 'left', scopedSlots: { customRender: 'studentName' } },
  { title: '签约校区', dataIndex: 'studio_id', key: '4' },
  { title: '课程科目', dataIndex: 'course_cate_id', key: '6' },
  { title: '剩余天数', dataIndex: 'left_days', key: '7',sorter:()=>{} },
  { title: '状态', dataIndex: 'contract_status_name', key: '10' },
  { title: '操作', key: 'operation', fixed: 'right', width:160, scopedSlots: { customRender: 'action' }},
]
import C_ITEMS from '@/utils/items'
import editModal from '../xfbj/editModal'
import tableMixins from '@/common/mixins/table'
export default {
  name: 'gjjl',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    editModal,
  },

  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,
      selectedRowKeys: [],

      dealStatus: C_ITEMS.dealStatus,
      studios: [],
      consultants: [],
      channels: [],

      searchData: {},

      visible: false,
      modalData: {},
      editVisible: false,
    }
  },
  mixins:[tableMixins],
  created() {
    this.getStudio()
    this.getConsultant()
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    closeSearch() {
      this.visible = false
    },
    async getStudio() {
      let res = await this.$store.dispatch('searchBelongStudioAction', {})
      this.studios = res.data
    },

    async getConsultant() {
      let res = await this.$store.dispatch('searchConsultantAction', {})
      this.consultants = res.data
    },
    async getList() {
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          if (k === 'created_date') {
            obj['start_date'] = searchData[k][0]
            obj['end_date'] = searchData[k][1]
          } else {
            obj[k] = searchData[k]
          }
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('extendingLimitAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    handleChange(pagination, filters, sorter){
        if(sorter.order){
            if(sorter.order === "ascend"){
                this.searchParams['sort'] = `${sorter.field}`
            }else{
                this.searchParams['sort'] = `-${sorter.field}`
            }
            }else{
            this.searchParams['sort'] = ''
            }
        this.getList()
    },
    showEditModal(item) {
      if (item) {
        this.modalData = [item.student_id]
      } else {
        this.modalData = this.selectedRowKeys
      }
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.selectedRowKeys = []
      this.editVisible = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    toProfile(item) {
      this.$router.push(`/work/profile/${item.student_id}`)
    }
  }
}
</script>
